export const EMPTY_VALUE_REGEX = /^<[a-zA-Z0-9]+><br><\/[a-zA-Z0-9]+>$/g;

export const EDITOR_TOOLBAR_HEIGHT = 44;
export const EDITOR_HEIGHT = 400;

const TOOLBAR_OPTIONS = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["link"],
  [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  ["clean"],
];

export const MODULES = {
  toolbar: TOOLBAR_OPTIONS,
  clipboard: {
    matchVisual: false,
  },
};
